// @flow
const linkMDN = (path: string): string => (
  `https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference${path}`
);

export const LUX_TYPES: Set<string> = new Set([
  'Application',
  'Controller',
  'Model',
  'Logger',
  'Serializer'
]);

export const TYPE_LINKS: Map<string, string> = new Map([
  ['Array', linkMDN('/Global_Objects/Array')],
  ['ArrayBuffer', linkMDN('/Global_Objects/ArrayBuffer')],
  ['Atomics', linkMDN('/Global_Objects/Atomics')],
  ['Boolean', linkMDN('/Global_Objects/Boolean')],
  ['DataView', linkMDN('/Global_Objects/DataView')],
  ['Date', linkMDN('/Global_Objects/Date')],
  ['Error', linkMDN('/Global_Objects/Error')],
  ['EvalError', linkMDN('/Global_Objects/EvalError')],
  ['Float32Array', linkMDN('/Global_Objects/Float32Array')],
  ['Float64Array', linkMDN('/Global_Objects/Float64Array')],
  ['Function', linkMDN('/Global_Objects/Function')],
  ['Generator', linkMDN('/Global_Objects/Generator')],
  ['GeneratorFunction', linkMDN('/Global_Objects/GeneratorFunction')],
  ['Infinity', linkMDN('/Global_Objects/Infinity')],
  ['Int16Array', linkMDN('/Global_Objects/Int16Array')],
  ['Int32Array', linkMDN('/Global_Objects/Int32Array')],
  ['Int8Array', linkMDN('/Global_Objects/Int8Array')],
  ['InternalError', linkMDN('/Global_Objects/InternalError')],
  ['Intl', linkMDN('/Global_Objects/Intl')],
  ['Intl.Collator', linkMDN('/Global_Objects/Intl.Collator')],
  ['Intl.DateTimeFormat', linkMDN('/Global_Objects/Intl.DateTimeFormat')],
  ['Intl.NumberFormat', linkMDN('/Global_Objects/Intl.NumberFormat')],
  ['Iterator', linkMDN('/Global_Objects/Iterator')],
  ['JSON', linkMDN('/Global_Objects/JSON')],
  ['Map', linkMDN('/Global_Objects/Map')],
  ['Math', linkMDN('/Global_Objects/Math')],
  ['NaN', linkMDN('/Global_Objects/NaN')],
  ['Number', linkMDN('/Global_Objects/Number')],
  ['Object', linkMDN('/Global_Objects/Object')],
  ['ParallelArray', linkMDN('/Global_Objects/ParallelArray')],
  ['Promise', linkMDN('/Global_Objects/Promise')],
  ['Proxy', linkMDN('/Global_Objects/Proxy')],
  ['RangeError', linkMDN('/Global_Objects/RangeError')],
  ['ReferenceError', linkMDN('/Global_Objects/ReferenceError')],
  ['Reflect', linkMDN('/Global_Objects/Reflect')],
  ['RegExp', linkMDN('/Global_Objects/RegExp')],
  ['SIMD', linkMDN('/Global_Objects/SIMD')],
  ['SIMD.Bool16x8', linkMDN('/Global_Objects/SIMD.Bool16x8')],
  ['SIMD.Bool32x4', linkMDN('/Global_Objects/SIMD.Bool32x4')],
  ['SIMD.Bool64x2', linkMDN('/Global_Objects/SIMD.Bool64x2')],
  ['SIMD.Bool8x16', linkMDN('/Global_Objects/SIMD.Bool8x16')],
  ['SIMD.Float32x4', linkMDN('/Global_Objects/SIMD.Float32x4')],
  ['SIMD.Float64x2', linkMDN('/Global_Objects/SIMD.Float64x2')],
  ['SIMD.Int16x8', linkMDN('/Global_Objects/SIMD.Int16x8')],
  ['SIMD.Int32x4', linkMDN('/Global_Objects/SIMD.Int32x4')],
  ['SIMD.Int8x16', linkMDN('/Global_Objects/SIMD.Int8x16')],
  ['SIMD.Uint16x8', linkMDN('/Global_Objects/SIMD.Uint16x8')],
  ['SIMD.Uint32x4', linkMDN('/Global_Objects/SIMD.Uint32x4')],
  ['SIMD.Uint8x16', linkMDN('/Global_Objects/SIMD.Uint8x16')],
  ['Set', linkMDN('/Global_Objects/Set')],
  ['SharedArrayBuffer', linkMDN('/Global_Objects/SharedArrayBuffer')],
  ['StopIteration', linkMDN('/Global_Objects/StopIteration')],
  ['String', linkMDN('/Global_Objects/String')],
  ['Symbol', linkMDN('/Global_Objects/Symbol')],
  ['SyntaxError', linkMDN('/Global_Objects/SyntaxError')],
  ['TypeError', linkMDN('/Global_Objects/TypeError')],
  ['TypedArray', linkMDN('/Global_Objects/TypedArray')],
  ['URIError', linkMDN('/Global_Objects/URIError')],
  ['Uint16Array', linkMDN('/Global_Objects/Uint16Array')],
  ['Uint32Array', linkMDN('/Global_Objects/Uint32Array')],
  ['Uint8Array', linkMDN('/Global_Objects/Uint8Array')],
  ['Uint8ClampedArray', linkMDN('/Global_Objects/Uint8ClampedArray')],
  ['WeakMap', linkMDN('/Global_Objects/WeakMap')],
  ['WeakSet', linkMDN('/Global_Objects/WeakSet')],
  ['decodeURI()', linkMDN('/Global_Objects/decodeURI()')],
  ['decodeURIComponent()', linkMDN('/Global_Objects/decodeURIComponent()')],
  ['encodeURI()', linkMDN('/Global_Objects/encodeURI()')],
  ['encodeURIComponent()', linkMDN('/Global_Objects/encodeURIComponent()')],
  ['escape()', linkMDN('/Global_Objects/escape()')],
  ['eval()', linkMDN('/Global_Objects/eval()')],
  ['isFinite()', linkMDN('/Global_Objects/isFinite()')],
  ['isNaN()', linkMDN('/Global_Objects/isNaN()')],
  ['null', linkMDN('/Global_Objects/null')],
  ['parseFloat()', linkMDN('/Global_Objects/parseFloat()')],
  ['parseInt()', linkMDN('/Global_Objects/parseInt()')],
  ['undefined', linkMDN('/Global_Objects/undefined')],
  ['unescape()', linkMDN('/Global_Objects/unescape()')],
  ['uneval()', linkMDN('/Global_Objects/uneval()')],
  ['Request', 'https://goo.gl/OzIDex'],
  ['Response', 'https://goo.gl/xrOh5n']
]);



// WEBPACK FOOTER //
// ./src/components/Type/constants.js